import cx from 'clsx'
import { forwardRef, HTMLAttributes, PropsWithChildren } from 'react'
import { WithClassName } from '../../types/utils'
import { OnClickProps } from '../../utils/onClickProps'

type TableRowProps = WithClassName &
  HTMLAttributes<HTMLTableRowElement> & {
    clickable?: OnClickProps
    archived?: boolean
  }

export const TableRow = forwardRef<HTMLTableRowElement, PropsWithChildren<TableRowProps>>(({ children, clickable, archived, className, onClick, ...rest }, ref) => {
  const isClickable = !!clickable && !archived

  return (
    <tr
      ref={ref}
      onClick={(e) => {
        clickable?.onClick(e)
        onClick?.(e)
      }}
      className={cx('bg-white', 'hover-gradient-platinum', isClickable ? 'cursor-pointer' : 'cursor-auto', archived && 'text-silver', className)}
      data-tracking={clickable?.trackingLabel}
      {...rest}
    >
      {children}
    </tr>
  )
})

export default TableRow
